import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {ICompany} from "../../company-create/models/company";
import {ServerEndpoints} from "../../../../server.endpoints";

@Injectable({
  providedIn: 'root'
})
export class CompanyHttpService {

  constructor(private http: HttpClient, @Inject("BASE_URL") private base: string) {
  }

  list(): Observable<ICompany[]> {
    return this.http.get<ICompany[]>(`${this.base}${ServerEndpoints.Management_Company__v2025_4}`);
  }
}
